import api from '../../api';
import {parseZodSchema} from '../../models/parseZodSchema';
import {userMeBookingFor, type UserMeBookingFor} from '../../models/user/userMeBookingForModel';

export function getUsersMeBookingForAllowed(): Promise<UserMeBookingFor[]> {
    return api
        .get('/api/user/allowedToBookFor')
        .then(api.handle)
        .catch(api.error)
        .then(raw => parseZodSchema(raw, userMeBookingFor.array()));
}
